module.exports = __webpack_public_path__ + "media/images/images-0e832924.png";